import { render, staticRenderFns } from "./TrainingMenu.vue?vue&type=template&id=1794b802&scoped=true&"
import script from "./TrainingMenu.vue?vue&type=script&lang=ts&"
export * from "./TrainingMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingMenu.vue?vue&type=style&index=0&id=1794b802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794b802",
  null
  
)

export default component.exports